export default "__VITE_ASSET__3ZLLXIGr__"